var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 262 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-1,.cls-2{stroke-width:0px;}.cls-3{clip-path:url(#clippath-2);}.cls-4{isolation:isolate;}.cls-2{fill:none;}.cls-5{clip-path:url(#clippath-1);}.cls-6{clip-path:url(#clippath);}.cls-7{clip-path:url(#clippath-3);}.cls-8{mask:url(#mask);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -6.73,
    y: -0.01,
    width: 268.46,
    height: 95.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -7.11,
    y: -0.01,
    width: 342.32,
    height: 86.02
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -7.2,
    y: -0.01,
    width: 342.4,
    height: 86.13,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_26224c3ec0"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-4",
    width: 1211,
    height: 305,
    transform: "translate(-7.2 -.01) scale(.28)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 189.03,
    y: 19.41,
    width: 72.7,
    height: 76.12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.87,93.65c.95,0,1.92-.33,2.68-1.04h.01c.81-.75,1.24-1.75,1.28-2.77.04-1.02-.31-2.05-1.05-2.86l-16.82-18.25c-.29-.31-.69-.48-1.09-.5h-.05c-.41,0-.79.13-1.09.41l-3.52,3.23c-.31.3-.49.7-.51,1.1,0,.4.12.82.43,1.14l16.82,18.24c.74.81,1.74,1.24,2.75,1.28h.05s.11,0,.11,0h0ZM235.68,69.83l2.11-1.95-3.09-3.36-.16.16-.33.32c-.52.51-1.07.99-1.63,1.46l3.1,3.36h0ZM215.64,66.07c5.45,0,10.41-2.17,14.04-5.7,3.69-3.59,6.01-8.59,6.08-14.14v-.26c0-5.45-2.17-10.41-5.71-14.04-3.6-3.68-8.6-6-14.16-6.07h-.18c-5.54,0-10.5,2.17-14.13,5.7-3.69,3.59-6.01,8.59-6.08,14.14v.26c0,5.45,2.17,10.41,5.71,14.04,3.59,3.68,8.6,6,14.16,6.07h.27ZM215.64,67.96h-.2c-6.18-.08-11.65-2.61-15.58-6.64-3.88-3.98-6.26-9.39-6.25-15.35v-.29c.08-6.07,2.62-11.54,6.66-15.45,3.96-3.87,9.39-6.24,15.35-6.24h.3c6.08.08,11.55,2.62,15.49,6.65,3.86,3.96,6.24,9.38,6.24,15.34v.29c-.08,6.07-2.62,11.54-6.65,15.47-3.98,3.85-9.4,6.23-15.37,6.23h0ZM215.64,70.65c6.7,0,12.78-2.66,17.24-6.99,4.53-4.41,7.37-10.54,7.46-17.36v-.32c0-6.68-2.66-12.78-7-17.22-4.41-4.52-10.55-7.37-17.38-7.46h-.22c-6.8,0-12.89,2.67-17.34,7-4.53,4.4-7.38,10.54-7.47,17.35v.32c0,6.7,2.67,12.78,7.02,17.23,4.4,4.52,10.55,7.36,17.37,7.45h.22s.11,0,.11,0ZM255.92,95.53h-.19c-1.59-.07-3.07-.7-4.17-1.88l-16.82-18.25c-.65-.71-.95-1.61-.91-2.49.02-.6.21-1.19.54-1.71l-3.3-3.58c-4.36,3.1-9.68,4.92-15.42,4.92h-.24c-7.46-.1-14.08-3.15-18.82-8.02-4.69-4.79-7.56-11.34-7.55-18.54v-.34c.1-7.33,3.16-13.94,8.04-18.68,4.79-4.67,11.35-7.54,18.55-7.54h.36c7.35.1,13.95,3.16,18.71,8.03,4.67,4.79,7.54,11.34,7.54,18.54v.34c-.09,6.41-2.43,12.26-6.27,16.8l3.31,3.59c.48-.24,1.01-.36,1.53-.36h.1c.94.04,1.82.41,2.47,1.12l16.82,18.25c1.08,1.18,1.59,2.7,1.53,4.21-.06,1.48-.68,2.95-1.86,4.04l-.02.03c-1.12,1.01-2.53,1.53-3.93,1.53h0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 27.39,
    y1: 223.63,
    x2: 27.65,
    y2: 223.63,
    gradientTransform: "translate(-7369.54 61694.88) scale(276 -275.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f68720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f68620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f68520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#f58420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f58320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#f58120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#f48020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#f47f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#f47e20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#f47d21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f47c21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f37b21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f37b21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#f37a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#f37921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f27821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f27721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f27621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#f27521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#f27421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f17421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f17321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f17221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f17121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f17021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#f06f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#f06e22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#f06d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f06c22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ef6c22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ef6b22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ef6a22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ef6922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ef6822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ee6722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#e62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ee6522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ee6522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ee6422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ed6322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ed6222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ed6122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ed6023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ed5f23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ec5e23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ec5d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ec5d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ec5c23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#eb5b23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#eb5a23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#eb5923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#eb5823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#eb5723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ea5623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ea5623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ea5523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ea5423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ea5323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#e95224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e95124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e95024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#e94f24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#e84e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#e84e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#e84d24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#e84c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#e84b24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#e74a24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#e74924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e74824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e74724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#e74724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#e64624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#e64524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e64424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e64325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e64225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e54125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e54025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e54025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e53f25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#e43e25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#e43d25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#e43c25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#e43b25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#e43a25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#e33925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e33825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e33825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#e33725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#e33625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#e23526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e23426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e23326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#e23226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#e13126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#e13126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#e13026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#e12f26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#e12e26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e02d26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e02c26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#e02b26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#e02a26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#e02926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#df2926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#df2826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#df2726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#df2627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#df2527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#de2427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#de2327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#de2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#de2227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#dd2127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#dd2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#dd1f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#dc1f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#dc1f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#db1f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#db1e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#da1e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#da1e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#d91e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#d91e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d81d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d81d28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d71d28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d71d28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d61d28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d61d28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d51c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d51c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#d41c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#d41c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d31c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d31c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d21b28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#d11b28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#d11b28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#d01b28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#d01b28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#cf1a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#cf1a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ce1a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ce1a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#cd1a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#cd1a29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#cc1929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#cc1929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#cb1929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#cb1929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ca1929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ca1829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#c91829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#c91829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#c81829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#c81829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#c71829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#c71729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#c61729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#c51729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#c51729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#c41729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#c41729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#c31629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c31629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c21629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c2162a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c1162a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c1152a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#c0152a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#c0152a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#bf152a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#bf152a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#be152a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#be142a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#bd142a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#bd142a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#bc142a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#bc142a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#bb132a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ba132a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ba132a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#b9132a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#b9132a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#b8132a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#b8122a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#b7122b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#b7122b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#b6122b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#b6122b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#b5122b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#b5112b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#b4112b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#b4112b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#b3112b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#b3112b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#b2102b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#b2102b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#b1102b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#b0102b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#b0102b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#af0f2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ae0f2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ae0f2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ad0e2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ac0e2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ab0e2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ab0d2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#aa0d2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#a90d2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#a90d2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#a80c2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#a70c2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a70c2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a60b2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a50b2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a40b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a40a29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#a30a29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#a20a29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#a20a29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#a10929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#a00929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9f0929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9f0829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9e0829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9d0828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9d0728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9c0728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9b0728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9b0728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#9a0628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#990628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#980628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#980528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#970528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#960528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#960427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#950427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#940427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#930427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#930327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#920327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#910327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#910227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#900227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#8f0227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#8f0126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#8e0126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8d0126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8c0126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c0026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b0026"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-4",
    width: 1211,
    height: 305,
    transform: "translate(-7.2 -.01) scale(.28)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.03,19.41v76.12h72.7V19.41h-72.7Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatIcon);
export default __webpack_public_path__ + "static/media/MatIcon.b43c92c03677c81a6f648c9ae6f74dd4.svg";
export { ForwardRef as ReactComponent };